// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"531da60a","177":"b26c70b1","219":"0a5cee26","627":"ac0d7038","679":"5176fd20","845":"2a77debf","855":"ab2fe03f"}[chunkId] + ".chunk.css";
};